// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CxJW","content":"styles_content__XXWSz"};